// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from '../core/BaseButton';
import UIButton from '../core/components/UIButton';
/* START-USER-IMPORTS */
import { CharacterSkins, CharacterSkinsValues } from '../CharacterSpine';
import { Player } from '../Player';
import { PlayerController } from '../PlayerController';
/* END-USER-IMPORTS */

export default class BtnSwitch extends BaseButton {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 68.5, y ?? 72.5);

    // btn
    const btn = scene.add.image(0, 0, 'common', 'btn-bear-select.png');
    this.add(btn);

    // iconBear
    const iconBear = scene.add.image(0, 0, 'common', 'icon-selected-grizz.png');
    this.add(iconBear);

    // btnKeyboard
    const btnKeyboard = scene.add.image(87, 34, 'common', 'btn-keyboard.png');
    btnKeyboard.visible = false;
    this.add(btnKeyboard);

    // iconEnter
    const iconEnter = scene.add.image(94, 34, 'common', 'btn-keyboard-enter.png');
    iconEnter.scaleX = 0.75;
    iconEnter.scaleY = 0.75;
    this.add(iconEnter);

    // lists
    const desktopVisibleList = [iconEnter];
    const mobileVisibleList: Array<any> = [];

    // this (components)
    const thisUIButton = new UIButton(this);
    thisUIButton.desktopVisibleList = desktopVisibleList;
    thisUIButton.mobileVisibleList = mobileVisibleList;
    thisUIButton.pulseScaleEnd = 1.1;
    thisUIButton.pulseSpeed = 1000;

    this.iconBear = iconBear;
    this.desktopVisibleList = desktopVisibleList;
    this.mobileVisibleList = mobileVisibleList;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private iconBear: Phaser.GameObjects.Image;
  private desktopVisibleList: Phaser.GameObjects.Image[];
  private mobileVisibleList: Array<any>;
  public iconGrizz: { key: string; frame?: string | number } = { key: 'common', frame: 'icon-selected-grizz.png' };
  public iconPanda: { key: string; frame?: string | number } = { key: 'common', frame: 'icon-selected-panda.png' };
  public iconIce: { key: string; frame?: string | number } = { key: 'common', frame: 'icon-selected-ice.png' };

  /* START-USER-CODE */

  public awake() {
    this.scene.events.on(Player.events.SwitchedCharacter, this.setCharacter, this);

    this.on(Phaser.Input.Events.POINTER_DOWN, () => {
      this.scene.events.emit(PlayerController.events.Switch);
    });
  }

  public destroy(fromScene?: boolean | undefined): void {
    this.scene.events.off(Player.events.SwitchedCharacter, this.setCharacter, this);
    this.off(Phaser.Input.Events.POINTER_DOWN);

    super.destroy(fromScene);
  }

  protected setCharacter(character: CharacterSkinsValues) {
    switch (character) {
      case CharacterSkins.Grizzly:
        this.iconBear.setTexture(this.iconGrizz.key, this.iconGrizz.frame);
        break;
      case CharacterSkins.Panda:
        this.iconBear.setTexture(this.iconPanda.key, this.iconPanda.frame);
        break;
      case CharacterSkins.Ice:
        this.iconBear.setTexture(this.iconIce.key, this.iconIce.frame);
        break;
      default:
        break;
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
